import MainPage from "./pages/MainPage";
import DistantPage from "./pages/DistantPage";
import LessonsPage from "./pages/LessonsPage";
import "./pages/main-page.css";
import "./pages/distant-page.css";
import "./pages/lessons-page.css";
import "./app.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/distant" element={<DistantPage />} />
        <Route path="/lessons-page" element={<LessonsPage />} />
      </Routes>
    </Router>
  );
}

export default App;